/** @jsxImportSource @emotion/react */

import { useState } from "react";
import { FindFormContainer, LoginBtnContainer, TitleSection } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { css } from "@emotion/react";
import AlertModal from "uis/modal/alert-modal";
import VerifyEmail from "pages/auth/component/verify-email";
import { sendEmailVerificatoinByForgotPassword, verifyEmailCode } from "apis/auth/email-verification";
import { googleLogin } from "apis/google";

const VerifyAccount = ({ onClickNext, setEmailVerificationToken }: { onClickNext?: () => void, setEmailVerificationToken: React.Dispatch<React.SetStateAction<string>> }) => {
  const [showGoogleAlertModal, setShowGoogleAlertModal] = useState<boolean>(false);
  const [showSignUpAlertModal, setShowSignUpAlertModal] = useState<boolean>(false);
  const [successVerify, setSuccessVerify] = useState<boolean>(false);

  const sendRequestVerifyEmail = async (email: string) : Promise<{ success: boolean; message: string }> => {
    const res = await sendEmailVerificatoinByForgotPassword(email);
    if (res.success) {
      return {success: res?.success, message: res?.message};
    } else {
      if (res?.statusCode === 404) {
        setShowSignUpAlertModal(true);
        return { success: false, message: "가입되지 않은 이메일입니다." };
      } else if (res?.statusCode === 409) {
        setShowGoogleAlertModal(true);
        return { success: false, message: "구글로 가입된 이메일입니다." };
      } else {
        return { success: false, message: "처리 중 문제가 발생했습니다. 다시 시도해주세요." };
      }
    }
  };

  const verifyCode = async (email: string, code: string) : Promise<{ success: boolean; message: string }> => {
    const res = await verifyEmailCode(email, code);
    if (res?.success) {
      setSuccessVerify(true);
      setEmailVerificationToken(res.emailVerificationToken);
    }
    
    return { success: res?.success ?? false, message: res?.message ?? "" };
  };

  const navigateSignUpPage = () => {
    window.location.href = "/sign-up";
  }

  return (
    <>
      <FindFormContainer>
        <TitleSection>
          <UI.Typography type="title01" fontStyle="bold" color="var(--alias-color-label-normal)">
            비밀번호 재설정
          </UI.Typography>
          <UI.Typography type="heading02" fontStyle="medium" color="var(--alias-color-label-alternative)">
            Mile에 가입한 이메일 주소를 입력해 주세요.
          </UI.Typography>
        </TitleSection>
        <div
          css={css`
            margin: 80px 0 40px 0%;
          `}
        >
          <VerifyEmail onHandleSendRequestVerifyEmail={sendRequestVerifyEmail} onHandleVerifyCode={verifyCode} />
        </div>
        <LoginBtnContainer>
          <UI.Button size="large" title="다음" disabled={successVerify ? false : true} onClick={successVerify ? onClickNext : () => {}} />
        </LoginBtnContainer>
      </FindFormContainer>
      <AlertModal
        title="구글로 가입된 이메일입니다."
        btnTitle="구글로 로그인하기"
        onChange={googleLogin}
        modalIsOpen={showGoogleAlertModal}
        closeModal={() => setShowGoogleAlertModal(false)}
      />
      <AlertModal
        title="가입되지 않은 이메일입니다."
        btnTitle="Mile 회원가입 하기"
        onChange={navigateSignUpPage}
        modalIsOpen={showSignUpAlertModal}
        closeModal={() => setShowSignUpAlertModal(false)}
      />
    </>
  );
};

export default VerifyAccount;
